import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";

import useAuth from "hooks/useAuth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return <div className="py-5 text-center">Carregando...</div>;
        }

        if (!isAuthenticated) {
          return (
            <Redirect
              to={{
                pathname: "/auth/login",
                state: { from: props.location?.pathname },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
